import { authRequest } from './client';
import { type AdminAccountResponse, type CreateAdminInput, type UpdateAdminInput } from './types';

// ─── backoffice-api admins client ──────────────────────────────────────────
//
// Thin fetch wrappers around backoffice-api's `/v1/admins` endpoints. No
// pagination on the list endpoint (backend doesn't support any). Every route
// is SUPERADMIN-only on the backend (see admins.controller.ts's class-level
// `@Roles(SUPERADMIN)`) — there is no partial-access tier to mirror
// client-side the way merchants' viewer/manager split works.

export function listAdmins(): Promise<AdminAccountResponse[]> {
  return authRequest<AdminAccountResponse[]>('/admins');
}

export function createAdmin(input: CreateAdminInput): Promise<AdminAccountResponse> {
  return authRequest<AdminAccountResponse>('/admins', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function updateAdmin(id: string, input: UpdateAdminInput): Promise<AdminAccountResponse> {
  return authRequest<AdminAccountResponse>(`/admins/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}
